import React from "react";
import { useNavigate } from "react-router-dom";
import "./Plantinumjubliee.css";
const pltLogo = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Pjc+module/pjc+logo+(1).webp";

const Plantinumjubliee = () => {
    const navigate = useNavigate();
    const handleContribute = () => {
        navigate("/alumni-landing");
    }
      

  return (
    <div className="plantinumjubliee">
      <div className="hl1"></div>

      <div className="container-fluid noun">
        <div className="plantinumjubliee-text">
          <p className="name">Platinum Jubilee Celebration</p>
          <p className="plantinumjubliee-desc">
            Dear Esteemed Alumni,
            Greetings from the Platinum Jubilee Committee of{" "}
            <strong>
              Alagappa Chettiar Government College of Engineering & Technology
              (ACCET), Karaikudi    </strong>
             As ACCET proudly celebrates{" "}
            <strong>75 years of excellence</strong>, we honor a rich legacy of
            academic achievement, innovation, and service established by our
            founder, <strong>Dr. Alagappa Chettiar</strong>. For generations,
            the institution has shaped accomplished engineers, entrepreneurs,
            academicians, and leaders who have made a lasting impact across the
            world. To mark this historic milestone, the Platinum Jubilee Committee has
            launched an initiative to strengthen and modernize the college's
            infrastructure, including academic facilities, laboratories, and
            student amenities. Your generous support will help create a better
            learning environment for future generations and ensure that ACCET's
            legacy of excellence continues for years to come.
            Together, let us celebrate our proud heritage by investing in the
            future of our beloved alma mater.
          </p>

          <div className="pjc_button">
           <button className="pjc-btn" onClick={handleContribute}>Read More</button>
          </div>
        </div>

        <img
          src={pltLogo}
          className="plantinumjubliee-pic"
          alt="Platinum Jubilee"
        />
      </div>

      <div className="hl1"></div>
    </div>
  );
};

export default Plantinumjubliee;
    